var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRupee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#161848;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.3,16.5H43c-0.6-2.9-1.8-5.6-3.6-8h15.9c2.1,0,3.8-1.7,3.8-3.8s-1.7-3.8-3.8-3.8H8.7c-2.1,0-3.8,1.7-3.8,3.8 s1.7,3.8,3.8,3.8h0c0,0,0,0,0,0H24c3.1,0,6.1,1.2,8.3,3.4c1.3,1.3,2.2,2.8,2.8,4.5H8.7c-2.1,0-3.8,1.7-3.8,3.8s1.7,3.8,3.8,3.8h26.4 c-1.6,4.6-6,8-11.1,8H8.9c-1.2-0.1-2.5,0.5-3.3,1.5c-1.3,1.7-0.9,4.1,0.8,5.3l31.1,23.3c0.7,0.5,1.5,0.8,2.3,0.8 c1.2,0,2.3-0.5,3.1-1.5c1.3-1.7,0.9-4.1-0.8-5.3L20.2,39.8H24c9.4,0,17.3-6.7,19-15.6h12.3c2.1,0,3.8-1.7,3.8-3.8 S57.4,16.5,55.3,16.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.5b7e2004f86cd1d957cd12a35a81f6ea.svg";
export { ForwardRef as ReactComponent };